// import { useTranslation } from "react-i18next";
// import dayjs from "dayjs";
// import { getDateFormatByLocal } from "../../../src/utils/dateTime";

// export const useEpochFormatter = () => {
//   const { i18n } = useTranslation();

//   const format = (input, appendFormat = "", notAppend = false) => {
//     if (!input && input !== 0) return "-";

//     const dateFormat = getDateFormatByLocal(i18n.language);
//     const finalFormat = notAppend
//       ? appendFormat
//       : appendFormat
//       ? `${dateFormat} ${appendFormat}`
//       : dateFormat;

//     let date;

//     if (typeof input === "number") {
//       date = dayjs.unix(input); // epoch seconds
//     } else if (typeof input === "string" || input instanceof Date) {
//       date = dayjs(input);
//     } else {
//       return input;
//     }

//     return date.isValid() ? date.format(finalFormat) : input;
//   };

//   return format;
// };


import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { getDateFormatByLocal } from "../../../src/utils/dateTime";

dayjs.extend(relativeTime);

export const useEpochFormatter = () => {
  const { i18n } = useTranslation();

  const format = (
    input,
    appendFormat = "",
    notAppend = false,
    relative = false,
  ) => {
    if (!input && input !== 0) return "-";

    let date;

    if (typeof input === "number") {
      date = dayjs.unix(input); // epoch seconds
    } else if (typeof input === "string" || input instanceof Date) {
      date = dayjs(input);
    } else {
      return input;
    }

    if (!date.isValid()) return input;

    if (relative) {
      return date.fromNow(); // example: 1 hour ago, a few seconds ago
    }

    const dateFormat = getDateFormatByLocal(i18n.language);

    const finalFormat = notAppend
      ? appendFormat
      : appendFormat
      ? `${dateFormat} ${appendFormat}`
      : dateFormat;

    return date.format(finalFormat);
  };

  return format;
};